var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5254 19.8453C77.8312 19.8453 80.5 17.1391 80.5 13.8108C80.5 10.4826 77.8312 7.77638 74.5254 7.77638C74.0402 7.77638 73.5549 7.83858 73.1 7.96301L72.5844 8.08743L72.5238 7.55864C72.0992 3.26608 68.5205 0 64.2443 0C60.9689 0 57.9664 1.95965 56.632 4.97688L56.5107 5.22573L56.2377 5.25683C54.1148 5.38125 52.2648 6.84321 51.6279 8.86507L51.4762 9.33165L51.0213 9.14502C50.3844 8.89618 49.6869 8.74064 48.9894 8.74064C45.9566 8.74064 43.5 11.2291 43.5 14.2774C43.5 17.2325 45.8049 19.6587 48.7164 19.8142H48.868H74.5254V19.8453Z",
    fill: "url(#paint0_linear_24135_41231)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 29C67.5 14.7419 55.7581 3 41.5 3C27.1371 3 15.5 14.7419 15.5 29C15.5 43.3629 27.1371 55 41.5 55C55.7581 55 67.5 43.3629 67.5 29ZM41.5 34.2419C44.121 34.2419 46.3226 36.4436 46.3226 39.0645C46.3226 41.7903 44.121 43.8871 41.5 43.8871C38.7742 43.8871 36.6774 41.7903 36.6774 39.0645C36.6774 36.4436 38.7742 34.2419 41.5 34.2419ZM36.8871 16.9435C36.7823 16.2097 37.4113 15.5806 38.1452 15.5806H44.75C45.4839 15.5806 46.1129 16.2097 46.0081 16.9435L45.2742 31.2016C45.1694 31.9355 44.6452 32.3548 44.0161 32.3548H38.879C38.25 32.3548 37.7258 31.9355 37.621 31.2016L36.8871 16.9435Z",
    fill: "#FA6F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67944 64.3902C2.70706 64.3902 -0.5 61.1383 -0.5 57.1388C-0.5 53.1393 2.70706 49.8874 6.67944 49.8874C7.26254 49.8874 7.84565 49.9622 8.39231 50.1117L9.01186 50.2612L9.08474 49.6258C9.59495 44.4676 13.8953 40.5428 19.0339 40.5428C22.9699 40.5428 26.5778 42.8977 28.1813 46.5234L28.3271 46.8224L28.6551 46.8598C31.2062 47.0093 33.4293 48.7661 34.1946 51.1957L34.3768 51.7564L34.9235 51.5321C35.6888 51.2331 36.527 51.0462 37.3652 51.0462C41.0096 51.0462 43.9615 54.0364 43.9615 57.6995C43.9615 61.2505 41.1918 64.166 37.6932 64.3528H37.511H6.67944V64.3902Z",
    fill: "url(#paint1_linear_24135_41231)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_24135_41231",
    x: 37.5,
    y: -6,
    width: 49,
    height: 31.8453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24135_41231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24135_41231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24135_41231",
    x: 9.5,
    y: 1,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.600747 0 0 0 0 0.597361 0 0 0 0 0.766667 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24135_41231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24135_41231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_24135_41231",
    x: -6.5,
    y: 34.5428,
    width: 56.4615,
    height: 35.8474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24135_41231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24135_41231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24135_41231",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 19.8453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708332,
    stopColor: "#F3E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24135_41231",
    x1: 21.7308,
    y1: 40.5428,
    x2: 21.7308,
    y2: 64.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708332,
    stopColor: "#F3E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24135_41231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionWarningIcon);
export default __webpack_public_path__ + "static/media/SubscriptionWarningIcon.9478b195.svg";
export { ForwardRef as ReactComponent };